import http from '../http-common';

class ManageWardService{
    saveSupplierWardDetails(data) {
        let formData = new FormData();
        formData.append("supplierCode", data.supplierCode);
        formData.append("file", data.file);

        console.info("---------", formData);
        return http.post("/wardmaster", formData, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        });
    }

    updateSupplierWardDetails(data){
        return http.put("/wardmaster",data);
    }

    getDestinationDtlsBySupplierCode(supplierCode){
        return http.get(`/wardmaster/${supplierCode}`);
    }
}

export default new ManageWardService();